module.exports = __webpack_public_path__ + "img/03.6ba42534.jpg";